import { PlusIcon } from 'components/icons';
import { useAppDispatch } from 'store';
import { addFilterClause } from 'store/composableFiltersSlice';

export const AddFilterClause = () => {
  const dispatch = useAppDispatch();

  return (
    <button
      className="flex items-center px-4 py-3 space-x-2 border rounded-segments-10px text-segments-accent-color-1"
      onClick={() => {
        dispatch(addFilterClause({ type: 'singleFilterClause' }));
      }}
    >
      <PlusIcon className="w-5 h-5 " />
      <p className="font-bold">Add a filter</p>
    </button>
  );
};

// * IMPORTANT - Real button disabled temporarily
// return (
//   <div className="relative">
//     <Menu>
//       {({ open }) => (
//         <>
//           <Menu.Button className="flex items-center px-4 py-3 space-x-2 border rounded-segments-10px text-segments-accent-color-1">
//             <PlusIcon className="w-5 h-5 " />
//             <p className="font-bold">Add a filter</p>
//           </Menu.Button>

//           <Transition
//             show={open}
//             enter="transition ease-out duration-100"
//             enterFrom="transform opacity-0 scale-95"
//             enterTo="transform opacity-100 scale-100"
//             leave="transition ease-in duration-75"
//             leaveFrom="transform opacity-100 scale-100"
//             leaveTo="transform opacity-0 scale-95"
//           >
//             <Menu.Items
//               static
//               className="absolute mt-2.5 origin-bottom-right bg-white border border-gray-200 rounded-2xl shadow-lg outline-none w-44 py-4 z-50"
//             >
//               <Menu.Item
//                 as="button"
//                 className="flex items-center w-full px-6 py-2 space-x-1 text-base leading-5 text-gray-700 hover:bg-segments-gray-F1"
//                 onClick={() => {
//                   dispatch(addFilterClause({ type: 'singleFilterClause' }));
//                 }}
//               >
//                 <p>Add a filter</p>
//               </Menu.Item>
//               <Menu.Item
//                 as="button"
//                 className="flex items-center w-full px-6 py-2 space-x-1 text-base leading-5 text-gray-700 hover:bg-segments-gray-F1"
//                 onClick={() => {
//                   dispatch(addFilterClause({ type: 'groupedFilterClause' }));
//                 }}
//               >
//                 <p>Add a filter group</p>
//               </Menu.Item>
//             </Menu.Items>
//           </Transition>
//         </>
//       )}
//     </Menu>
//   </div>
// );
